import styled from "styled-components";

export const MyButton = styled.button`
    background-color: #2563eb;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
    color: white;
    border: 0px;
    font-size: 100%;
    cursor: pointer;
`